export default __webpack_public_path__ + "static/media/active-time.23ad2ed4.svg";